import {combineReducers} from 'redux';
import ACTION from '../action_constant';

function browsePackages(
  state = {
    map: {},
    markers: [],
    mapData: [],
    list: {},
    selectedMarker: {
      lat: 0,
      lng: 0
    },
    offerData: {},
    offerConstants: {},
    browseFilter: {},
    isFilterActive: false
  },
  action
){
  let offerData = {};
  let offerConstants = {};
  let localState;
  switch (action.type){
    case ACTION.BROWSE_PACKAGES.BROWSE_PACKAGES:{
      let shipmentList;
      let nextUrl;
      let markers = [];
      let map;
      let list;
      let key;
      let mapData = [];
      let browseFilter = '';
      let pinIcon;

      (action.data && action.data.shipmentList) ? (shipmentList = action.data.shipmentList, nextUrl = action.data.nextUrl) : (shipmentList = null, nextUrl = null);

      if(action.data && action.data.shipmentList && action.isMapView){

        action.data.shipmentList.forEach((shipment, index) => {

          if(index == 0){
            pinIcon = "../../public/images/icons_png/location_pin_selected.png";
          }else{
            pinIcon = "../../public/images/icons_png/location_pin.png";
          }
          // create marker
          markers.push(
            {
              position: {
                lat:  Number(shipment.pickupLat),
                lng: Number(shipment.pickupLong),
              },
              defaultAnimation: 2,
              id: index,
              icon : pinIcon,
              isSelected: false
            }
          )
          // create mapData Object
          key = shipment.pickupLat.toFixed(5) + '-' + shipment.pickupLong.toFixed(5);
          mapData[key] = shipment;
          })

      }

      if(action.isMapView){
        map = Object.assign({}, state.map, {
                                            shipmentList: shipmentList,
                                            nextUrl: nextUrl
                                        });

          return Object.assign({}, state, { map: map,
                                            isMapView: action.isMapView,
                                            mapData: mapData,
                                            markers: markers,
                                            browseFilter: action.browseFilter,
                                            isFilterActive: action.isFilterActive
                                        });
      }
      else{
        list = Object.assign({}, state.list, {
                                              shipmentList: shipmentList,
                                              nextUrl: nextUrl
                                            });
        return Object.assign({}, state, {
                                              list: list,
                                              isMapView: action.isMapView,
                                              browseFilter: action.browseFilter,
                                              isFilterActive: action.isFilterActive
                                            });
      }

    }

    case ACTION.BROWSE_PACKAGES.BROWSE_PACKAGES_WITH_FILTERS: {
      return Object.assign({}, state, {
                                        data: action.data
                                      });
    }

    case ACTION.BROWSE_PACKAGES.UPDATE_MAP_VIEW : {
      let key = action.data.lat.toFixed(5) + '-' + action.data.lng.toFixed(5);
      let currShipment = state.mapData[key];
      let map  = Object.assign({}, state.map);
      let selectedMarker = Object.assign({}, state.selectedMarker);
      let markers =  state.markers;
      markers.forEach((marker, index) => {
        if(action.data.lat.toFixed(5) == marker.position.lat.toFixed(5) && action.data.lng.toFixed(5) == marker.position.lng.toFixed(5)){
          marker.icon = "../../public/images/icons_png/location_pin_selected.png";
          return false;
        }else{
          marker.icon = "../../public/images/icons_png/location_pin.png";
        }
      })

      map.shipmentList = [];
      map.shipmentList.push(currShipment);
      return Object.assign({}, state, { map: map,
                                        isMapView: action.isMapView,
                                        markers : markers,
                                        selectedMarker: selectedMarker
                                      });
    }

    case ACTION.BROWSE_PACKAGES.UPDATE_LIST_PACKAGES: {
      let list =  Object.assign({}, state.list);
      list.shipmentList =  [...list.shipmentList, ...action.data.shipmentList];
      list.nextUrl = action.data.nextUrl;

      return Object.assign({}, state, {
                                        list: list,
                                        isMapView: action.isMapView
                                      })
    }

    case ACTION.BROWSE_PACKAGES.OFFER_TO_CARRY_A_PACKAGE:
        offerData =  Object.assign({}, state.offerData, {isOfferMade: action.data.isOfferMade, shipmentId: action.data.shipmentId, shipperName: action.data.shipperName});
        return Object.assign({}, state, {offerData: offerData});

    case ACTION.BROWSE_PACKAGES.MAKE_OFFER:

        offerData =  Object.assign({}, state.offerData);
        if("offerData" in action)
        {
          offerData =  Object.assign({}, state.offerData, action.offerData);
        }
        return Object.assign({}, state, { offerData });

    case ACTION.BROWSE_PACKAGES.CLEAR_MAKE_OFFER_DATA:
            return Object.assign({}, state, { offerData : {} });

    case ACTION.BROWSE_PACKAGES.GET_PAYPAL_ACCOUNT:
        offerData = Object.assign({}, state.offerData);
        if(action.data.paypalId){
          offerData.paypalId = action.data.paypalId
        }
        return Object.assign({}, state, { offerData });

    case ACTION.BROWSE_PACKAGES.SET_PAYPAL_ACCOUNT:
        offerData = Object.assign({}, state.offerData);
        if(action.data.paypalId){
          offerData.paypalId = action.data.paypalId
        }
        return Object.assign({}, state, { offerData });

    case ACTION.BROWSE_PACKAGES.ENABLE_TRIPS:
        localState =  Object.assign({}, state);
        let browseFilterLocal = localState.browseFilter;
        browseFilterLocal.isMyTrips = true;
        return Object.assign({}, state, { browseFilter: browseFilterLocal, isFilterActive: action.isFilterActive});

    case ACTION.BROWSE_PACKAGES.CLEAR_MAP_DATA:
        localState =  Object.assign({}, state);
        let mapData = localState.map;
        if(mapData && mapData.shipmentList){
          mapData.shipmentList = [];
        }
        return Object.assign({}, state, { browseFilter: browseFilterLocal});

    default:
      return state
  }
}

module.exports = browsePackages;



// WEBPACK FOOTER //
// app/browse_packages/browse_packages_reducer.jsx